import image1 from 'images/resource-cards/resource-card-0.jpg';
import image2 from 'images/resource-cards/resource-card-1.jpg';
import image3 from 'images/resource-cards/resource-card-2.jpg';

export const data = [
    {
        title: 'Crop nutrition programs',
        text: 'Learn how to care for your plants, providing them with proper nutrition for maximum crop yield and health.',
        img: image1,
    },
    {
        title: 'Trial results',
        text: 'We showcase the results of our research on different groups of plants. Here you can find analyzes and conclusions on the effectiveness of products in increasing yields.',
        img: image2,
    },
    {
        title: 'Information materials',
        text: 'View our product catalogs, which provide detailed information in PDF format. Here you will find detailed descriptions of products, their composition, application and benefits for plants.',
        img: image3,
    },
];
